export const LayoutSplashScreen = () => {
  return (
    <div id='splash-screen' className='splash-screen'>
      <img
        src='/media/logos/starlight-logo.png'
        id='splash-screen-image'
        alt='School logo'
        width='100'
      />
      <span className='loading'></span>
    </div>
  )
}
